export const apiCreate = (): string => '/commercial/servicesCountries/'

export const apiList = (id?: string): string =>
  !id
    ? '/commercial/servicesCountries/'
    : `/commercial/servicesCountries/view/${id}`

export const apiListPagination = (): string =>
  '/commercial/servicesCountries/pagination'

export const apiUpdate = (id: string): string =>
  `/commercial/servicesCountries/update/${id}`

export const apiDelete = (id: string): string =>
  `/commercial/servicesCountries/${id}`

export const apiOptions = (): string => '/commercial/servicesCountries/options'
